import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { PaiementPrintComponent } from "../components/paiement-print/paiement-print.component";
import { PrintComponent } from "../components/print/print.component";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { ContentModule } from "app/layout/components/content/content.module";
import { NavbarModule } from "app/layout/components/navbar/navbar.module";
import { QuickPanelModule } from "app/layout/components/quick-panel/quick-panel.module";
import { ToolbarModule } from "app/layout/components/toolbar/toolbar.module";
import { MatButtonModule } from "@angular/material/button";
import { LayoutComponent } from "app/layout/layout/layout.component";
import { MatDividerModule } from "@angular/material/divider";
import { PlanningPrintComponent } from "app/layout/components/planning-print/planning-print.component";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TopNotificationModule } from "app/layout/components/top-notification/top-notification.module";
import { EmailConfirmationBannerModule } from "app/layout/components/email-confirmation-banner/email-confirmation-banner.module";
import { AgencyInvoicePrintModule } from "app/layout/components/agency-invoice-print/agency-invoice-print.module";
import { RecuAgencePaymentModule } from "app/layout/components/recu-agence-payment/recu-agence-payment.module";
import { SmallLayoutComponent } from "app/layout/small-layout/small-layout.component";
import { OnGoingEventComponent } from "../components/on-going-event/on-going-event.component";
import { TranslocoModule } from "@ngneat/transloco";
@NgModule({
  declarations: [
    LayoutComponent,
    PaiementPrintComponent,
    PrintComponent,
    PlanningPrintComponent,
  ],
  imports: [
    SmallLayoutComponent,
    AgencyInvoicePrintModule,
    RouterModule,
    MatButtonModule,
    FuseSharedModule,
    FuseSidebarModule,
    ContentModule,
    NavbarModule,
    QuickPanelModule,
    ToolbarModule,
    FlexLayoutModule,
    MatDividerModule,
    MatToolbarModule,
    MatIconModule,
    TopNotificationModule,
    EmailConfirmationBannerModule,
    RecuAgencePaymentModule,
    OnGoingEventComponent,
    TranslocoModule
  ],
  exports: [LayoutComponent],
})
export class LayoutModule { }
